<div class="photo-note-container">
  @if (photos.length > 0) {
    <swiper-container
      #swiperContainer
      [spaceBetween]="5"
      [slidesPerView]="1"
      [centeredSlides]="true"
      [pagination]="photos.length > 1 ? { clickable: true } : false"
      >
      @for (photo of photos; track photo; let i = $index) {
        <swiper-slide>
          <img class="img-photo" [src]="photo.photo_url"/>
          <span class="slide-index white-shadow">{{i+1}}/{{photos.length}}</span>
          @if (!noEdit) {
 <span tappable class="delete-button white-shadow"  (click)="confirmDeletePhoto(i)">&times;</span>
          }
          @if (!noEdit || photo.photo_note_caption) {
            <div class="photo-caption" [ngClass]="photo.photo_note_caption === '' ? 'empty-caption': 'full-caption'">
              @if (!noEdit) {
                <span class="pencil-icon"></span>
              }
              @if (!tempPhotos) {
                <form [formGroup]="photoCaption" class="caption-form">
                  <ion-textarea [disabled]="noEdit" tidyCustomTextarea [text]="photo.photo_note_caption | translate" placeholder="Add Caption" class="custom-textarea caption-input" [formControlName]="photo.id || photo.key" [runNgAfterViewChecked]="true">
                    <ion-spinner />
                  </ion-textarea>
                </form>
              }
              @if (tempPhotos) {
                <ion-textarea [(ngModel)]="photo.photo_note_caption" tidyCustomTextarea [text]="photo.photo_note_caption | translate" placeholder="Add Caption" class="custom-textarea caption-input" [runNgAfterViewChecked]="true">
                  <ion-spinner />
                </ion-textarea>
              }
            </div>
          }
        </swiper-slide>
      }
    </swiper-container>
  }
</div>
